import React from 'react';
import { CheckCircle, Clock, XCircle, Calendar, FileText } from 'lucide-react';

export const getEstadoBadge = (estado) => {
    let colorClass, text, Icon;
    switch (estado) {
        case 'pendiente':
            colorClass = 'bg-yellow-200 text-yellow-800';
            text = 'Pendiente';
            Icon = Clock;
            break;
        case 'en_diagnostico':
            colorClass = 'bg-cyan-200 text-cyan-900';
            text = 'En diagnóstico';
            Icon = Clock;
            break;
        case 'esperando_repuesto':
            colorClass = 'bg-amber-200 text-amber-900';
            text = 'Esperando repuesto';
            Icon = Clock;
            break;
        case 'presupuestado':
            colorClass = 'bg-indigo-200 text-indigo-900';
            text = 'Presupuestado';
            Icon = FileText;
            break;
        case 'completado':
            colorClass = 'bg-green-200 text-green-800';
            text = 'Completado';
            Icon = CheckCircle;
            break;
        case 'cancelado':
        case 'anulado':
            colorClass = 'bg-red-200 text-red-800';
            text = 'Cancelado';
            Icon = XCircle;
            break;
        case 'programado':
            colorClass = 'bg-blue-200 text-blue-800';
            text = 'Programado';
            Icon = Calendar;
            break;
        case 'documentos_enviados':
            colorClass = 'bg-purple-200 text-purple-800';
            text = 'Docs Enviados';
            Icon = FileText;
            break;
        default:
            colorClass = 'bg-gray-200 text-gray-800';
            text = 'Desconocido';
            Icon = null;
    }

    return (
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full ${colorClass}`}>
            {Icon && <Icon className="w-3.5 h-3.5" />}
            {text}
        </span>
    );
};
